export enum ClaimStateEnum {
    INACTIVE = 'inactive',
    ACTIVE = 'active',
    REVIEW = 'review',
    CONFIRMATION = 'confirmation'
}
